module.exports = __webpack_public_path__ + "static/media/undraw_doctor_kw5l.9a65492b.svg";